<p>
  wait-activity-view works!
</p>
